import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Coins } from 'lucide-react';
import { NeonButton } from './ui/NeonButton';
const STOREFRONT = 'https://cdn.magicpatterns.com/uploads/psRLaxDJGeC1tuTTYR71jb/Screenshot_2026-06-19_at_5.01.34_PM.png';
const BUY_TOKENS_URL = 'https://app.clawplanetarcade.com/buytokens';
const DIRECTIONS_URL = 'https://www.google.com/maps/dir//33.3909168,-111.6893387';
export function Hero() {
  return <section id="top" className="relative flex min-h-screen w-full items-center justify-center overflow-hidden starfield pt-24 pb-16" data-id="element-21">
      {/* storefront backdrop */}
      <div className="absolute inset-0" data-id="element-22">
        <img src={STOREFRONT} alt="Claw Planet Arcade storefront filled with glowing claw machines" className="h-full w-full object-cover opacity-30" data-id="element-23" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#05010f]/70 via-[#05010f]/80 to-[#05010f]" data-id="element-24" />
      </div>

      <div className="relative z-10 mx-auto max-w-4xl px-4 text-center sm:px-6" data-id="element-25">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="font-arcade text-5xl leading-[1.05] tracking-tight sm:text-7xl lg:text-8xl" data-id="element-26">
          <span className="neon-purple neon-flicker block" data-id="element-27">CLAW</span>
          <span className="neon-cyan block" data-id="element-28">PLANET</span>
          <span className="neon-pink block" data-id="element-29">ARCADE</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.25
      }} className="mx-auto mt-6 max-w-xl font-display text-base text-purple-100/85 sm:text-lg" data-id="element-30">
          Step into a galaxy of glowing claw machines. Grab plushies, win
          prizes, and light up your day at the brightest arcade in the mall.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row" data-id="element-31">
          <NeonButton href={BUY_TOKENS_URL} gated color="pink" pulse data-id="element-32">
            <Coins className="h-5 w-5" aria-hidden="true" data-id="element-33" />
            Buy Tokens
          </NeonButton>
          <NeonButton href={DIRECTIONS_URL} gated color="cyan" variant="outline" data-id="element-34">
            <MapPin className="h-5 w-5" aria-hidden="true" data-id="element-35" />
            Get Directions
          </NeonButton>
        </motion.div>
      </div>

      {/* scroll hint glow line */}
      <div className="pointer-events-none absolute bottom-0 left-1/2 h-24 w-px -translate-x-1/2 bg-gradient-to-b from-transparent via-cyan-400/60 to-cyan-400" data-id="element-36" />
    </section>;
}